import { cn } from '@/lib/utils';

interface TrendIndicatorProps {
  trend: 'up' | 'down' | 'stable';
  value?: string;
}

const ICONS: Record<TrendIndicatorProps['trend'], string> = {
  up: '↑',
  down: '↓',
  stable: '→',
};

const COLORS: Record<TrendIndicatorProps['trend'], string> = {
  up: 'text-[var(--domino-good)]',
  down: 'text-[var(--domino-critical)]',
  stable: 'text-[var(--domino-neutral)]',
};

export const TrendIndicator = ({ trend, value }: TrendIndicatorProps) => (
  <span className={cn('inline-flex items-center gap-1 text-sm font-medium', COLORS[trend])}>
    <span aria-hidden>{ICONS[trend]}</span>
    {value ?? trend}
  </span>
);
